import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrophoneMute = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.0001 18.0002V14.0002C14.9935 13.3418 15.1184 12.6887 15.3673 12.0791C15.6163 11.4695 15.9843 10.9157 16.4499 10.4501C16.9155 9.98451 17.4693 9.61646 18.0789 9.36751C18.6885 9.11855 19.3416 8.9937 20.0001 9.00024V9.00024C20.6585 8.9937 21.3116 9.11855 21.9212 9.36751C22.5308 9.61646 23.0846 9.98451 23.5502 10.4501C24.0158 10.9157 24.3838 11.4695 24.6328 12.0791C24.8818 12.6887 25.0066 13.3418 25.0001 14.0002",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.0001 31.0002H25.0001",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0001 27.0002V31.0002",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 15.0002V14.0002C25 12.6742 24.4733 11.4024 23.5356 10.4647C22.5979 9.52703 21.3261 9.00024 20 9.00024C18.674 9.00024 17.4022 9.52703 16.4645 10.4647C15.5268 11.4024 15 12.6742 15 14.0002V18.0002C14.9943 18.9002 15.2349 19.7846 15.6958 20.5575C16.1568 21.3305 16.8205 21.9626 17.615 22.3852",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.484 22.7583C22.2581 22.5262 22.9625 22.1056 23.5339 21.5342C24.1054 20.9627 24.526 20.2584 24.758 19.4843",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 18.0002C10.9954 19.4226 11.3295 20.8256 11.9748 22.0931C12.6202 23.3607 13.5581 24.4563 14.711 25.2892",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.577 26.6652C18.3659 26.8857 19.1809 26.9984 20 27.0002C21.1833 27.0051 22.3558 26.7757 23.45 26.3251C24.5441 25.8746 25.5382 25.2118 26.3749 24.3751C27.2116 23.5384 27.8744 22.5443 28.3249 21.4502C28.7755 20.356 29.0049 19.1835 29 18.0002",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0001 29.0002L29.0001 11.0002",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgMicrophoneMute);
export default ForwardRef;
